var items = {
  "block.minecraft.air": "อากาศ",
  "block.minecraft.stone": "หิน",
  "block.minecraft.granite": "หินแกรนิต",
  "block.minecraft.polished_granite": "หินแกรนิตขัด",
  "block.minecraft.diorite": "หินไดออไรต์",
  "block.minecraft.polished_diorite": "หินไดออไรต์ขัด",
  "block.minecraft.andesite": "หินแอนดีไซต์",
  "block.minecraft.polished_andesite": "หินแอนดีไซต์ขัด",
  "block.minecraft.grass_block": "บล็อกหญ้า",
  "block.minecraft.dirt": "ดิน",
  "block.minecraft.coarse_dirt": "ดินหยาบ",
  "block.minecraft.podzol": "ดินพอดซอล",
  "block.minecraft.crimson_nylium": "กลุ่มใยราเนเธอร์สีเลือด",
  "block.minecraft.warped_nylium": "กลุ่มใยราเนเธอร์ป่าวิปริต",
  "block.minecraft.cobblestone": "หินหยาบ",
  "block.minecraft.oak_planks": "แผ่นกระดานไม้โอ๊ก",
  "block.minecraft.spruce_planks": "แผ่นกระดานไม้สนสปรูซ",
  "block.minecraft.birch_planks": "แผ่นกระดานไม้เบิร์ช",
  "block.minecraft.jungle_planks": "แผ่นกระดานไม้ป่าดงดิบ",
  "block.minecraft.acacia_planks": "แผ่นกระดานไม้อะเคเซีย",
  "block.minecraft.dark_oak_planks": "แผ่นกระดานไม้โอ๊กดำ",
  "block.minecraft.crimson_planks": "แผ่นกระดานไม้สีเลือด",
  "block.minecraft.warped_planks": "แผ่นกระดานไม้ป่าวิปริต",
  "block.minecraft.oak_sapling": "ต้นอ่อนไม้โอ๊ก",
  "block.minecraft.spruce_sapling": "ต้นอ่อนไม้สนสปรูซ",
  "block.minecraft.birch_sapling": "ต้นอ่อนไม้เบิร์ช",
  "block.minecraft.jungle_sapling": "ต้นอ่อนไม้ป่าดงดิบ",
  "block.minecraft.acacia_sapling": "ต้นอ่อนไม้อะเคเซีย",
  "block.minecraft.dark_oak_sapling": "ต้นอ่อนไม้โอ๊กดำ",
  "block.minecraft.bedrock": "หินดาน",
  "block.minecraft.sand": "ทราย",
  "block.minecraft.red_sand": "ทรายแดง",
  "block.minecraft.gravel": "กรวด",
  "block.minecraft.gold_ore": "แร่ทอง",
  "block.minecraft.iron_ore": "แร่เหล็ก",
  "block.minecraft.coal_ore": "แร่ถ่านหิน",
  "block.minecraft.nether_gold_ore": "แร่ทองเนเธอร์",
  "block.minecraft.oak_log": "ท่อนไม้โอ๊ก",
  "block.minecraft.spruce_log": "ท่อนไม้สนสปรูซ",
  "block.minecraft.birch_log": "ท่อนไม้เบิร์ช",
  "block.minecraft.jungle_log": "ท่อนไม้ป่าดงดิบ",
  "block.minecraft.acacia_log": "ท่อนไม้อะเคเซีย",
  "block.minecraft.dark_oak_log": "ท่อนไม้โอ๊กดำ",
  "block.minecraft.crimson_stem": "ลำต้นสีเลือด",
  "block.minecraft.warped_stem": "ลำต้นป่าวิปริต",
  "block.minecraft.stripped_oak_log": "ท่อนไม้โอ๊กลอก",
  "block.minecraft.stripped_spruce_log": "ท่อนไม้สนสปรูซลอก",
  "block.minecraft.stripped_birch_log": "ท่อนไม้เบิร์ชลอก",
  "block.minecraft.stripped_jungle_log": "ท่อนไม้ป่าดงดิบลอก",
  "block.minecraft.stripped_acacia_log": "ท่อนไม้อะเคเซียลอก",
  "block.minecraft.stripped_dark_oak_log": "ท่อนไม้โอ๊กดำลอก",
  "block.minecraft.stripped_crimson_stem": "ลำต้นสีเลือดลอก",
  "block.minecraft.stripped_warped_stem": "ลำต้นป่าวิปริตลอก",
  "block.minecraft.stripped_oak_wood": "ไม้โอ๊กลอก",
  "block.minecraft.stripped_spruce_wood": "ไม้สนสปรูซลอก",
  "block.minecraft.stripped_birch_wood": "ไม้เบิร์ชลอก",
  "block.minecraft.stripped_jungle_wood": "ไม้ป่าดงดิบลอก",
  "block.minecraft.stripped_acacia_wood": "ไม้อะเคเซียลอก",
  "block.minecraft.stripped_dark_oak_wood": "ไม้โอ๊กดำลอก",
  "block.minecraft.stripped_crimson_hyphae": "เส้นใยเห็ดราสีเลือดลอก",
  "block.minecraft.stripped_warped_hyphae": "เส้นใยเห็ดราป่าวิปริตลอก",
  "block.minecraft.oak_wood": "ไม้โอ๊ก",
  "block.minecraft.spruce_wood": "ไม้สนสปรูซ",
  "block.minecraft.birch_wood": "ไม้เบิร์ช",
  "block.minecraft.jungle_wood": "ไม้ป่าดงดิบ",
  "block.minecraft.acacia_wood": "ไม้อะเคเซีย",
  "block.minecraft.dark_oak_wood": "ไม้โอ๊กดำ",
  "block.minecraft.crimson_hyphae": "เส้นใยเห็ดราสีเลือด",
  "block.minecraft.warped_hyphae": "เส้นใยเห็ดราป่าวิปริต",
  "block.minecraft.oak_leaves": "ใบไม้โอ๊ก",
  "block.minecraft.spruce_leaves": "ใบไม้สนสปรูซ",
  "block.minecraft.birch_leaves": "ใบไม้เบิร์ช",
  "block.minecraft.jungle_leaves": "ใบไม้ป่าดงดิบ",
  "block.minecraft.acacia_leaves": "ใบไม้อะเคเซีย",
  "block.minecraft.dark_oak_leaves": "ใบไม้โอ๊กดำ",
  "block.minecraft.sponge": "ฟองน้ำ",
  "block.minecraft.wet_sponge": "ฟองน้ำเปียก",
  "block.minecraft.glass": "กระจก",
  "block.minecraft.lapis_ore": "แร่แลพิสแลซูลี",
  "block.minecraft.lapis_block": "บล็อกแลพิสแลซูลี",
  "block.minecraft.dispenser": "เครื่องยิง",
  "block.minecraft.sandstone": "หินทราย",
  "block.minecraft.chiseled_sandstone": "หินทรายสลัก",
  "block.minecraft.cut_sandstone": "หินทรายตัด",
  "block.minecraft.note_block": "กล่องตัวโน้ต",
  "block.minecraft.powered_rail": "รางขับเคลื่อน",
  "block.minecraft.detector_rail": "รางตรวจจับ",
  "block.minecraft.sticky_piston": "ลูกสูบเหนียว",
  "block.minecraft.cobweb": "ใยแมงมุม",
  "block.minecraft.grass": "หญ้า",
  "block.minecraft.fern": "เฟิน",
  "block.minecraft.dead_bush": "พุ่มไม้แห้ง",
  "block.minecraft.seagrass": "หญ้าทะเล",
  "block.minecraft.sea_pickle": "แตงกวาดองทะเล",
  "block.minecraft.piston": "ลูกสูบ",
  "block.minecraft.white_wool": "ขนแกะสีขาว",
  "block.minecraft.orange_wool": "ขนแกะสีส้ม",
  "block.minecraft.magenta_wool": "ขนแกะสีบานเย็น",
  "block.minecraft.light_blue_wool": "ขนแกะสีฟ้า",
  "block.minecraft.yellow_wool": "ขนแกะสีเหลือง",
  "block.minecraft.lime_wool": "ขนแกะสีเขียวอ่อน",
  "block.minecraft.pink_wool": "ขนแกะสีชมพู",
  "block.minecraft.gray_wool": "ขนแกะสีเทา",
  "block.minecraft.light_gray_wool": "ขนแกะสีเทาอ่อน",
  "block.minecraft.cyan_wool": "ขนแกะสีฟ้าคราม",
  "block.minecraft.purple_wool": "ขนแกะสีม่วง",
  "block.minecraft.blue_wool": "ขนแกะสีน้ำเงิน",
  "block.minecraft.brown_wool": "ขนแกะสีน้ำตาล",
  "block.minecraft.green_wool": "ขนแกะสีเขียว",
  "block.minecraft.red_wool": "ขนแกะสีแดง",
  "block.minecraft.black_wool": "ขนแกะสีดำ",
  "block.minecraft.dandelion": "ดอกแดนดิไลออน",
  "block.minecraft.poppy": "ดอกป๊อปปี้",
  "block.minecraft.blue_orchid": "กล้วยไม้น้ำเงิน",
  "block.minecraft.allium": "ดอกอัลเลียม",
  "block.minecraft.azure_bluet": "ดอกแอเชอร์บลูเอ็ต",
  "block.minecraft.red_tulip": "ดอกทิวลิปแดง",
  "block.minecraft.orange_tulip": "ดอกทิวลิปส้ม",
  "block.minecraft.white_tulip": "ดอกทิวลิปขาว",
  "block.minecraft.pink_tulip": "ดอกทิวลิปชมพู",
  "block.minecraft.oxeye_daisy": "ดอกอ๊อกซายเดซี่",
  "block.minecraft.cornflower": "คอร์นฟลาวเวอร์",
  "block.minecraft.lily_of_the_valley": "ลิลลี่หุบเขา",
  "block.minecraft.wither_rose": "กุหลาบวิทเธอร์",
  "block.minecraft.brown_mushroom": "เห็ดน้ำตาล",
  "block.minecraft.red_mushroom": "เห็ดแดง",
  "block.minecraft.crimson_fungus": "เห็ดราสีเลือด",
  "block.minecraft.warped_fungus": "เห็ดราป่าวิปริต",
  "block.minecraft.crimson_roots": "รากไม้สีเลือด",
  "block.minecraft.warped_roots": "รากไม้ป่าวิปริต",
  "block.minecraft.nether_sprouts": "ต้นอ่อนเนเธอร์",
  "block.minecraft.weeping_vines": "เถาวัลย์โศก",
  "block.minecraft.twisting_vines": "เถาวัลย์บิดเกลียว",
  "block.minecraft.sugar_cane": "อ้อย",
  "block.minecraft.kelp": "สาหร่ายทะเล",
  "block.minecraft.bamboo": "ไม้ไผ่",
  "block.minecraft.gold_block": "บล็อกทอง",
  "block.minecraft.iron_block": "บล็อกเหล็ก",
  "block.minecraft.oak_slab": "แผ่นไม้โอ๊ก",
  "block.minecraft.spruce_slab": "แผ่นไม้สนสปรูซ",
  "block.minecraft.birch_slab": "แผ่นไม้เบิร์ช",
  "block.minecraft.jungle_slab": "แผ่นไม้ป่าดงดิบ",
  "block.minecraft.acacia_slab": "แผ่นไม้อะเคเซีย",
  "block.minecraft.dark_oak_slab": "แผ่นไม้โอ๊กดำ",
  "block.minecraft.crimson_slab": "แผ่นไม้สีเลือด",
  "block.minecraft.warped_slab": "แผ่นไม้ป่าวิปริต",
  "block.minecraft.stone_slab": "แผ่นหิน",
  "block.minecraft.smooth_stone_slab": "แผ่นหินเรียบ",
  "block.minecraft.sandstone_slab": "แผ่นหินทราย",
  "block.minecraft.cut_sandstone_slab": "แผ่นหินทรายตัด",
  "block.minecraft.petrified_oak_slab": "แผ่นไม้โอ๊กกลายเป็นหิน",
  "block.minecraft.cobblestone_slab": "แผ่นหินหยาบ",
  "block.minecraft.brick_slab": "แผ่นอิฐ",
  "block.minecraft.stone_brick_slab": "แผ่นอิฐหิน",
  "block.minecraft.nether_brick_slab": "แผ่นอิฐเนเธอร์",
  "block.minecraft.quartz_slab": "แผ่นควอตซ์",
  "block.minecraft.red_sandstone_slab": "แผ่นหินทรายแดง",
  "block.minecraft.cut_red_sandstone_slab": "แผ่นหินทรายแดงตัด",
  "block.minecraft.purpur_slab": "แผ่นเพอร์เพอร์",
  "block.minecraft.prismarine_slab": "แผ่นพริสมารีน",
  "block.minecraft.prismarine_brick_slab": "แผ่นอิฐพริสมารีน",
  "block.minecraft.dark_prismarine_slab": "แผ่นพริสมารีนเข้ม",
  "block.minecraft.smooth_quartz": "บล็อกควอตซ์เรียบ",
  "block.minecraft.smooth_red_sandstone": "หินทรายแดงเรียบ",
  "block.minecraft.smooth_sandstone": "หินทรายเรียบ",
  "block.minecraft.smooth_stone": "หินเรียบ",
  "block.minecraft.bricks": "อิฐ",
  "block.minecraft.tnt": "ระเบิดทีเอ็นที",
  "block.minecraft.bookshelf": "ชั้นหนังสือ",
  "block.minecraft.mossy_cobblestone": "หินหยาบมอสส์",
  "block.minecraft.obsidian": "หินออบซิเดียน",
  "block.minecraft.torch": "คบเพลิง",
  "block.minecraft.end_rod": "แท่งเอนด์",
  "block.minecraft.chorus_plant": "ต้นคอรัส",
  "block.minecraft.chorus_flower": "ดอกคอรัส",
  "block.minecraft.purpur_block": "บล็อกเพอร์เพอร์",
  "block.minecraft.purpur_pillar": "เสาเพอร์เพอร์",
  "block.minecraft.purpur_stairs": "บันไดเพอร์เพอร์",
  "block.minecraft.spawner": "เครื่องกำเนิด",
  "block.minecraft.oak_stairs": "บันไดไม้โอ๊ก",
  "block.minecraft.chest": "หีบ",
  "block.minecraft.diamond_ore": "แร่เพชร",
  "block.minecraft.diamond_block": "บล็อกเพชร",
  "block.minecraft.crafting_table": "โต๊ะคราฟต์",
  "block.minecraft.farmland": "บล็อกทำฟาร์ม",
  "block.minecraft.furnace": "เตาเผา",
  "block.minecraft.ladder": "บันไดลิง",
  "block.minecraft.rail": "ราง",
  "block.minecraft.cobblestone_stairs": "บันไดหินหยาบ",
  "block.minecraft.lever": "คันโยก",
  "block.minecraft.stone_pressure_plate": "แป้นเหยียบหิน",
  "block.minecraft.oak_pressure_plate": "แป้นเหยียบไม้โอ๊ก",
  "block.minecraft.spruce_pressure_plate": "แป้นเหยียบไม้สนสปรูซ",
  "block.minecraft.birch_pressure_plate": "แป้นเหยียบไม้เบิร์ช",
  "block.minecraft.jungle_pressure_plate": "แป้นเหยียบไม้ป่าดงดิบ",
  "block.minecraft.acacia_pressure_plate": "แป้นเหยียบไม้อะเคเซีย",
  "block.minecraft.dark_oak_pressure_plate": "แป้นเหยียบไม้โอ๊กดำ",
  "block.minecraft.crimson_pressure_plate": "แป้นเหยียบไม้สีเลือด",
  "block.minecraft.warped_pressure_plate": "แป้นเหยียบไม้ป่าวิปริต",
  "block.minecraft.polished_blackstone_pressure_plate": "แป้นเหยียบหินดำขัด",
  "block.minecraft.redstone_ore": "แร่เรดสโตน",
  "block.minecraft.redstone_torch": "คบเพลิงเรดสโตน",
  "block.minecraft.snow": "หิมะ",
  "block.minecraft.ice": "น้ำแข็ง",
  "block.minecraft.snow_block": "บล็อกหิมะ",
  "block.minecraft.cactus": "กระบองเพชร",
  "block.minecraft.clay": "ดินเหนียว",
  "block.minecraft.jukebox": "ตู้เพลง",
  "block.minecraft.oak_fence": "รั้วไม้โอ๊ก",
  "block.minecraft.spruce_fence": "รั้วไม้สนสปรูซ",
  "block.minecraft.birch_fence": "รั้วไม้เบิร์ช",
  "block.minecraft.jungle_fence": "รั้วไม้ป่าดงดิบ",
  "block.minecraft.acacia_fence": "รั้วไม้อะเคเซีย",
  "block.minecraft.dark_oak_fence": "รั้วไม้โอ๊กดำ",
  "block.minecraft.crimson_fence": "รั้วไม้สีเลือด",
  "block.minecraft.warped_fence": "รั้วไม้ป่าวิปริต",
  "block.minecraft.pumpkin": "ฟักทอง",
  "block.minecraft.carved_pumpkin": "ฟักทองแกะสลัก",
  "block.minecraft.netherrack": "หินเนเธอร์",
  "block.minecraft.soul_sand": "ทรายวิญญาณ",
  "block.minecraft.soul_soil": "ดินวิญญาณ",
  "block.minecraft.basalt": "หินบะซอลต์",
  "block.minecraft.polished_basalt": "หินบะซอลต์ขัด",
  "block.minecraft.soul_torch": "คบเพลิงวิญญาณ",
  "block.minecraft.glowstone": "หินเรืองแสง",
  "block.minecraft.jack_o_lantern": "โคมไฟฟักทอง",
  "block.minecraft.oak_trapdoor": "ประตูกับดักไม้โอ๊ก",
  "block.minecraft.spruce_trapdoor": "ประตูกับดักไม้สนสปรูซ",
  "block.minecraft.birch_trapdoor": "ประตูกับดักไม้เบิร์ช",
  "block.minecraft.jungle_trapdoor": "ประตูกับดักไม้ป่าดงดิบ",
  "block.minecraft.acacia_trapdoor": "ประตูกับดักไม้อะเคเซีย",
  "block.minecraft.dark_oak_trapdoor": "ประตูกับดักไม้โอ๊กดำ",
  "block.minecraft.crimson_trapdoor": "ประตูกับดักไม้สีเลือด",
  "block.minecraft.warped_trapdoor": "ประตูกับดักไม้ป่าวิปริต",
  "block.minecraft.infested_stone": "หินติดเชื้อ",
  "block.minecraft.infested_cobblestone": "หินหยาบติดเชื้อ",
  "block.minecraft.infested_stone_bricks": "อิฐหินติดเชื้อ",
  "block.minecraft.infested_mossy_stone_bricks": "อิฐหินมอสส์ติดเชื้อ",
  "block.minecraft.infested_cracked_stone_bricks": "อิฐหินร้าวติดเชื้อ",
  "block.minecraft.infested_chiseled_stone_bricks": "อิฐหินสลักติดเชื้อ",
  "block.minecraft.stone_bricks": "อิฐหิน",
  "block.minecraft.mossy_stone_bricks": "อิฐหินมอสส์",
  "block.minecraft.cracked_stone_bricks": "อิฐหินร้าว",
  "block.minecraft.chiseled_stone_bricks": "อิฐหินสลัก",
  "block.minecraft.brown_mushroom_block": "บล็อกเห็ดน้ำตาล",
  "block.minecraft.red_mushroom_block": "บล็อกเห็ดแดง",
  "block.minecraft.mushroom_stem": "ลำต้นเห็ด",
  "block.minecraft.iron_bars": "ลูกกรงเหล็ก",
  "block.minecraft.chain": "โซ่",
  "block.minecraft.glass_pane": "แผ่นกระจก",
  "block.minecraft.melon": "แตงโม",
  "block.minecraft.vine": "เถาวัลย์",
  "block.minecraft.oak_fence_gate": "ประตูรั้วไม้โอ๊ก",
  "block.minecraft.spruce_fence_gate": "ประตูรั้วไม้สนสปรูซ",
  "block.minecraft.birch_fence_gate": "ประตูรั้วไม้เบิร์ช",
  "block.minecraft.jungle_fence_gate": "ประตูรั้วไม้ป่าดงดิบ",
  "block.minecraft.acacia_fence_gate": "ประตูรั้วไม้อะเคเซีย",
  "block.minecraft.dark_oak_fence_gate": "ประตูรั้วไม้โอ๊กดำ",
  "block.minecraft.crimson_fence_gate": "ประตูรั้วไม้สีเลือด",
  "block.minecraft.warped_fence_gate": "ประตูรั้วไม้ป่าวิปริต",
  "block.minecraft.brick_stairs": "บันไดอิฐ",
  "block.minecraft.stone_brick_stairs": "บันไดอิฐหิน",
  "block.minecraft.mycelium": "กลุ่มใยรา",
  "block.minecraft.lily_pad": "ใบบัว",
  "block.minecraft.nether_bricks": "อิฐเนเธอร์",
  "block.minecraft.cracked_nether_bricks": "อิฐเนเธอร์ร้าว",
  "block.minecraft.chiseled_nether_bricks": "อิฐเนเธอร์สลัก",
  "block.minecraft.nether_brick_fence": "รั้วอิฐเนเธอร์",
  "block.minecraft.nether_brick_stairs": "บันไดอิฐเนเธอร์",
  "block.minecraft.enchanting_table": "โต๊ะร่ายมนตร์",
  "block.minecraft.end_portal_frame": "กรอบประตูมิติเอนด์",
  "block.minecraft.end_stone": "หินเอนด์",
  "block.minecraft.end_stone_bricks": "อิฐหินเอนด์",
  "block.minecraft.dragon_egg": "ไข่มังกร",
  "block.minecraft.redstone_lamp": "หลอดไฟเรดสโตน",
  "block.minecraft.sandstone_stairs": "บันไดหินทราย",
  "block.minecraft.emerald_ore": "แร่มรกต",
  "block.minecraft.ender_chest": "หีบเอนเดอร์",
  "block.minecraft.tripwire_hook": "ตะขอกับดักเชือก",
  "block.minecraft.emerald_block": "บล็อกมรกต",
  "block.minecraft.spruce_stairs": "บันไดไม้สนสปรูซ",
  "block.minecraft.birch_stairs": "บันไดไม้เบิร์ช",
  "block.minecraft.jungle_stairs": "บันไดไม้ป่าดงดิบ",
  "block.minecraft.crimson_stairs": "บันไดไม้สีเลือด",
  "block.minecraft.warped_stairs": "บันไดไม้ป่าวิปริต",
  "block.minecraft.command_block": "บล็อกคำสั่ง",
  "block.minecraft.beacon": "ดวงประทีป",
  "block.minecraft.cobblestone_wall": "กำแพงหินหยาบ",
  "block.minecraft.mossy_cobblestone_wall": "กำแพงหินหยาบมอสส์",
  "block.minecraft.brick_wall": "กำแพงอิฐ",
  "block.minecraft.prismarine_wall": "กำแพงพริสมารีน",
  "block.minecraft.red_sandstone_wall": "กำแพงหินทรายแดง",
  "block.minecraft.mossy_stone_brick_wall": "กำแพงอิฐหินมอสส์",
  "block.minecraft.granite_wall": "กำแพงหินแกรนิต",
  "block.minecraft.stone_brick_wall": "กำแพงอิฐหิน",
  "block.minecraft.nether_brick_wall": "กำแพงอิฐเนเธอร์",
  "block.minecraft.andesite_wall": "กำแพงหินแอนดีไซต์",
  "block.minecraft.red_nether_brick_wall": "กำแพงอิฐเนเธอร์แดง",
  "block.minecraft.sandstone_wall": "กำแพงหินทราย",
  "block.minecraft.end_stone_brick_wall": "กำแพงอิฐหินเอนด์",
  "block.minecraft.diorite_wall": "กำแพงหินไดออไรต์",
  "block.minecraft.blackstone_wall": "กำแพงหินดำ",
  "block.minecraft.polished_blackstone_wall": "กำแพงหินดำขัด",
  "block.minecraft.polished_blackstone_brick_wall": "กำแพงอิฐหินดำขัด",
  "block.minecraft.stone_button": "ปุ่มหิน",
  "block.minecraft.oak_button": "ปุ่มไม้โอ๊ก",
  "block.minecraft.spruce_button": "ปุ่มไม้สนสปรูซ",
  "block.minecraft.birch_button": "ปุ่มไม้เบิร์ช",
  "block.minecraft.jungle_button": "ปุ่มไม้ป่าดงดิบ",
  "block.minecraft.acacia_button": "ปุ่มไม้อะเคเซีย",
  "block.minecraft.dark_oak_button": "ปุ่มไม้โอ๊กดำ",
  "block.minecraft.crimson_button": "ปุ่มไม้สีเลือด",
  "block.minecraft.warped_button": "ปุ่มไม้ป่าวิปริต",
  "block.minecraft.polished_blackstone_button": "ปุ่มหินดำขัด",
  "block.minecraft.anvil": "ทั่ง",
  "block.minecraft.chipped_anvil": "ทั่งบิ่น",
  "block.minecraft.damaged_anvil": "ทั่งเสียหาย",
  "block.minecraft.trapped_chest": "หีบกับดัก",
  "block.minecraft.light_weighted_pressure_plate": "แป้นเหยียบถ่วงน้ำหนักเบา",
  "block.minecraft.heavy_weighted_pressure_plate": "แป้นเหยียบถ่วงน้ำหนักหนัก",
  "block.minecraft.daylight_detector": "เครื่องตรวจจับแสงแดด",
  "block.minecraft.redstone_block": "บล็อกเรดสโตน",
  "block.minecraft.nether_quartz_ore": "แร่ควอตซ์เนเธอร์",
  "block.minecraft.hopper": "ท่อส่ง",
  "block.minecraft.chiseled_quartz_block": "บล็อกควอตซ์สลัก",
  "block.minecraft.quartz_block": "บล็อกควอตซ์",
  "block.minecraft.quartz_bricks": "อิฐควอตซ์",
  "block.minecraft.quartz_pillar": "เสาควอตซ์",
  "block.minecraft.quartz_stairs": "บันไดควอตซ์",
  "block.minecraft.activator_rail": "รางจุดฉนวน",
  "block.minecraft.dropper": "เครื่องดรอป",
  "block.minecraft.white_terracotta": "ดินเผาสีขาว",
  "block.minecraft.orange_terracotta": "ดินเผาสีส้ม",
  "block.minecraft.magenta_terracotta": "ดินเผาสีบานเย็น",
  "block.minecraft.light_blue_terracotta": "ดินเผาสีฟ้า",
  "block.minecraft.yellow_terracotta": "ดินเผาสีเหลือง",
  "block.minecraft.lime_terracotta": "ดินเผาสีเขียวอ่อน",
  "block.minecraft.pink_terracotta": "ดินเผาสีชมพู",
  "block.minecraft.gray_terracotta": "ดินเผาสีเทา",
  "block.minecraft.light_gray_terracotta": "ดินเผาสีเทาอ่อน",
  "block.minecraft.cyan_terracotta": "ดินเผาสีฟ้าคราม",
  "block.minecraft.purple_terracotta": "ดินเผาสีม่วง",
  "block.minecraft.blue_terracotta": "ดินเผาสีน้ำเงิน",
  "block.minecraft.brown_terracotta": "ดินเผาสีน้ำตาล",
  "block.minecraft.green_terracotta": "ดินเผาสีเขียว",
  "block.minecraft.red_terracotta": "ดินเผาสีแดง",
  "block.minecraft.black_terracotta": "ดินเผาสีดำ",
  "block.minecraft.barrier": "บาร์เรียร์",
  "block.minecraft.iron_trapdoor": "ประตูกับดักเหล็ก",
  "block.minecraft.hay_block": "กองฟาง",
  "block.minecraft.white_carpet": "พรมสีขาว",
  "block.minecraft.orange_carpet": "พรมสีส้ม",
  "block.minecraft.magenta_carpet": "พรมสีบานเย็น",
  "block.minecraft.light_blue_carpet": "พรมสีฟ้า",
  "block.minecraft.yellow_carpet": "พรมสีเหลือง",
  "block.minecraft.lime_carpet": "พรมสีเขียวอ่อน",
  "block.minecraft.pink_carpet": "พรมสีชมพู",
  "block.minecraft.gray_carpet": "พรมสีเทา",
  "block.minecraft.light_gray_carpet": "พรมสีเทาอ่อน",
  "block.minecraft.cyan_carpet": "พรมสีฟ้าคราม",
  "block.minecraft.purple_carpet": "พรมสีม่วง",
  "block.minecraft.blue_carpet": "พรมสีน้ำเงิน",
  "block.minecraft.brown_carpet": "พรมสีน้ำตาล",
  "block.minecraft.green_carpet": "พรมสีเขียว",
  "block.minecraft.red_carpet": "พรมสีแดง",
  "block.minecraft.black_carpet": "พรมสีดำ",
  "block.minecraft.terracotta": "ดินเผา",
  "block.minecraft.coal_block": "บล็อกถ่านหิน",
  "block.minecraft.packed_ice": "น้ำแข็งอัดแน่น",
  "block.minecraft.acacia_stairs": "บันไดไม้อะเคเซีย",
  "block.minecraft.dark_oak_stairs": "บันไดไม้โอ๊กดำ",
  "block.minecraft.slime_block": "บล็อกสไลม์",
  "block.minecraft.grass_path": "ทางเดินหญ้า",
  "block.minecraft.sunflower": "ดอกทานตะวัน",
  "block.minecraft.lilac": "ดอกไลแล็ก",
  "block.minecraft.rose_bush": "พุ่มกุหลาบ",
  "block.minecraft.peony": "ดอกโบตั๋น",
  "block.minecraft.tall_grass": "หญ้าสูง",
  "block.minecraft.large_fern": "เฟิร์นใหญ่",
  "block.minecraft.white_stained_glass": "กระจกสีขาว",
  "block.minecraft.orange_stained_glass": "กระจกสีส้ม",
  "block.minecraft.magenta_stained_glass": "กระจกสีบานเย็น",
  "block.minecraft.light_blue_stained_glass": "กระจกสีฟ้า",
  "block.minecraft.yellow_stained_glass": "กระจกสีเหลือง",
  "block.minecraft.lime_stained_glass": "กระจกสีเขียวอ่อน",
  "block.minecraft.pink_stained_glass": "กระจกสีชมพู",
  "block.minecraft.gray_stained_glass": "กระจกสีเทา",
  "block.minecraft.light_gray_stained_glass": "กระจกสีเทาอ่อน",
  "block.minecraft.cyan_stained_glass": "กระจกสีฟ้าคราม",
  "block.minecraft.purple_stained_glass": "กระจกสีม่วง",
  "block.minecraft.blue_stained_glass": "กระจกสีน้ำเงิน",
  "block.minecraft.brown_stained_glass": "กระจกสีน้ำตาล",
  "block.minecraft.green_stained_glass": "กระจกสีเขียว",
  "block.minecraft.red_stained_glass": "กระจกสีแดง",
  "block.minecraft.black_stained_glass": "กระจกสีดำ",
  "block.minecraft.white_stained_glass_pane": "แผ่นกระจกสีขาว",
  "block.minecraft.orange_stained_glass_pane": "แผ่นกระจกสีส้ม",
  "block.minecraft.magenta_stained_glass_pane": "แผ่นกระจกสีบานเย็น",
  "block.minecraft.light_blue_stained_glass_pane": "แผ่นกระจกสีฟ้า",
  "block.minecraft.yellow_stained_glass_pane": "แผ่นกระจกสีเหลือง",
  "block.minecraft.lime_stained_glass_pane": "บานกระจกสีเขียวอ่อน",
  "block.minecraft.pink_stained_glass_pane": "บานกระจกสีชมพู",
  "block.minecraft.gray_stained_glass_pane": "แผ่นกระจกสีเทา",
  "block.minecraft.light_gray_stained_glass_pane": "บานกระจกสีเทาอ่อน",
  "block.minecraft.cyan_stained_glass_pane": "แผ่นกระจกสีฟ้าคราม",
  "block.minecraft.purple_stained_glass_pane": "แผ่นกระจกสีม่วง",
  "block.minecraft.blue_stained_glass_pane": "แผ่นกระจกสีน้ำเงิน",
  "block.minecraft.brown_stained_glass_pane": "แผ่นกระจกสีน้ำตาล",
  "block.minecraft.green_stained_glass_pane": "แผ่นกระจกสีเขียว",
  "block.minecraft.red_stained_glass_pane": "แผ่นกระจกสีแดง",
  "block.minecraft.black_stained_glass_pane": "แผ่นกระจกสีดำ",
  "block.minecraft.prismarine": "พริสมารีน",
  "block.minecraft.prismarine_bricks": "อิฐพริสมารีน",
  "block.minecraft.dark_prismarine": "พริสมารีนเข้ม",
  "block.minecraft.prismarine_stairs": "บันไดพริสมารีน",
  "block.minecraft.prismarine_brick_stairs": "บันไดอิฐพริสมารีน",
  "block.minecraft.dark_prismarine_stairs": "บันไดพริสมารีนเข้ม",
  "block.minecraft.sea_lantern": "โคมไฟทะเล",
  "block.minecraft.red_sandstone": "หินทรายแดง",
  "block.minecraft.chiseled_red_sandstone": "หินทรายแดงสลัก",
  "block.minecraft.cut_red_sandstone": "หินทรายแดงตัด",
  "block.minecraft.red_sandstone_stairs": "บันไดหินทรายแดง",
  "block.minecraft.repeating_command_block": "บล็อกคำสั่งแบบทำซ้ำ",
  "block.minecraft.chain_command_block": "บล็อกคำสั่งแบบโซ่",
  "block.minecraft.magma_block": "บล็อกแม็กม่า",
  "block.minecraft.nether_wart_block": "บล็อกหูดเนเธอร์",
  "block.minecraft.warped_wart_block": "บล็อกหูดป่าวิปริต",
  "block.minecraft.red_nether_bricks": "อิฐเนเธอร์แดง",
  "block.minecraft.bone_block": "บล็อกกระดูก",
  "block.minecraft.structure_void": "บล็อกโครงเปล่า",
  "block.minecraft.observer": "ตัวสังเกตการณ์",
  "block.minecraft.shulker_box": "กล่องชัลเกอร์",
  "block.minecraft.white_shulker_box": "กล่องชัลเกอร์สีขาว",
  "block.minecraft.orange_shulker_box": "กล่องชัลเกอร์สีส้ม",
  "block.minecraft.magenta_shulker_box": "กล่องชัลเกอร์สีบานเย็น",
  "block.minecraft.light_blue_shulker_box": "กล่องชัลเกอร์สีฟ้า",
  "block.minecraft.yellow_shulker_box": "กล่องชัลเกอร์สีเหลือง",
  "block.minecraft.lime_shulker_box": "กล่องชัลเกอร์สีเขียวอ่อน",
  "block.minecraft.pink_shulker_box": "กล่องชัลเกอร์สีชมพู",
  "block.minecraft.gray_shulker_box": "กล่องชัลเกอร์สีเทา",
  "block.minecraft.light_gray_shulker_box": "กล่องชัลเกอร์สีเทาอ่อน",
  "block.minecraft.cyan_shulker_box": "กล่องชัลเกอร์สีฟ้าคราม",
  "block.minecraft.purple_shulker_box": "กล่องชัลเกอร์สีม่วง",
  "block.minecraft.blue_shulker_box": "กล่องชัลเกอร์สีน้ำเงิน",
  "block.minecraft.brown_shulker_box": "กล่องชัลเกอร์สีน้ำตาล",
  "block.minecraft.green_shulker_box": "กล่องชัลเกอร์สีเขียว",
  "block.minecraft.red_shulker_box": "กล่องชัลเกอร์สีแดง",
  "block.minecraft.black_shulker_box": "กล่องชัลเกอร์สีดำ",
  "block.minecraft.white_glazed_terracotta": "ดินเผาเคลือบสีขาว",
  "block.minecraft.orange_glazed_terracotta": "ดินเผาเคลือบสีส้ม",
  "block.minecraft.magenta_glazed_terracotta": "ดินเผาเคลือบสีบานเย็น",
  "block.minecraft.light_blue_glazed_terracotta": "ดินเผาเคลือบสีฟ้า",
  "block.minecraft.yellow_glazed_terracotta": "ดินเผาเคลือบสีเหลือง",
  "block.minecraft.lime_glazed_terracotta": "ดินเผาเคลือบสีเขียวอ่อน",
  "block.minecraft.pink_glazed_terracotta": "ดินเผาเคลือบสีชมพู",
  "block.minecraft.gray_glazed_terracotta": "ดินเผาเคลือบสีเทา",
  "block.minecraft.light_gray_glazed_terracotta": "ดินเผาเคลือบสีเทาอ่อน",
  "block.minecraft.cyan_glazed_terracotta": "ดินเผาเคลือบสีฟ้าคราม",
  "block.minecraft.purple_glazed_terracotta": "ดินเผาเคลือบสีม่วง",
  "block.minecraft.blue_glazed_terracotta": "ดินเผาเคลือบสีน้ำเงิน",
  "block.minecraft.brown_glazed_terracotta": "ดินเผาเคลือบสีน้ำตาล",
  "block.minecraft.green_glazed_terracotta": "ดินเผาเคลือบสีเขียว",
  "block.minecraft.red_glazed_terracotta": "ดินเผาเคลือบสีแดง",
  "block.minecraft.black_glazed_terracotta": "ดินเผาเคลือบสีดำ",
  "block.minecraft.white_concrete": "คอนกรีตสีขาว",
  "block.minecraft.orange_concrete": "คอนกรีตสีส้ม",
  "block.minecraft.magenta_concrete": "คอนกรีตสีบานเย็น",
  "block.minecraft.light_blue_concrete": "คอนกรีตสีฟ้า",
  "block.minecraft.yellow_concrete": "คอนกรีตสีเหลือง",
  "block.minecraft.lime_concrete": "คอนกรีตสีเขียวอ่อน",
  "block.minecraft.pink_concrete": "คอนกรีตสีชมพู",
  "block.minecraft.gray_concrete": "คอนกรีตสีเทา",
  "block.minecraft.light_gray_concrete": "คอนกรีตสีเทาอ่อน",
  "block.minecraft.cyan_concrete": "คอนกรีตสีฟ้าคราม",
  "block.minecraft.purple_concrete": "คอนกรีตสีม่วง",
  "block.minecraft.blue_concrete": "คอนกรีตสีน้ำเงิน",
  "block.minecraft.brown_concrete": "คอนกรีตสีน้ำตาล",
  "block.minecraft.green_concrete": "คอนกรีตสีเขียว",
  "block.minecraft.red_concrete": "คอนกรีตสีแดง",
  "block.minecraft.black_concrete": "คอนกรีตสีดำ",
  "block.minecraft.white_concrete_powder": "ผงคอนกรีตสีขาว",
  "block.minecraft.orange_concrete_powder": "ผงคอนกรีตสีส้ม",
  "block.minecraft.magenta_concrete_powder": "ผงคอนกรีตสีบานเย็น",
  "block.minecraft.light_blue_concrete_powder": "ผงคอนกรีตสีฟ้า",
  "block.minecraft.yellow_concrete_powder": "ผงคอนกรีตสีเหลือง",
  "block.minecraft.lime_concrete_powder": "ผงคอนกรีตสีเขียวอ่อน",
  "block.minecraft.pink_concrete_powder": "ผงคอนกรีตสีชมพู",
  "block.minecraft.gray_concrete_powder": "ผงคอนกรีตสีเทา",
  "block.minecraft.light_gray_concrete_powder": "ผงคอนกรีตสีเทาอ่อน",
  "block.minecraft.cyan_concrete_powder": "ผงคอนกรีตสีฟ้าคราม",
  "block.minecraft.purple_concrete_powder": "ผงคอนกรีตสีม่วง",
  "block.minecraft.blue_concrete_powder": "ผงคอนกรีตสีน้ำเงิน",
  "block.minecraft.brown_concrete_powder": "ผงคอนกรีตสีน้ำตาล",
  "block.minecraft.green_concrete_powder": "ผงคอนกรีตสีเขียว",
  "block.minecraft.red_concrete_powder": "ผงคอนกรีตสีแดง",
  "block.minecraft.black_concrete_powder": "ผงคอนกรีตสีดำ",
  "block.minecraft.turtle_egg": "ไข่เต่า",
  "block.minecraft.dead_tube_coral_block": "บล็อกปะการังหลอดตาย",
  "block.minecraft.dead_brain_coral_block": "บล็อกปะการังสมองตาย",
  "block.minecraft.dead_bubble_coral_block": "บล็อกปะการังฟองตาย",
  "block.minecraft.dead_fire_coral_block": "บล็อกปะการังไฟตาย",
  "block.minecraft.dead_horn_coral_block": "บล็อกปะการังเขาตาย",
  "block.minecraft.tube_coral_block": "บล็อกปะการังหลอด",
  "block.minecraft.brain_coral_block": "บล็อกปะการังสมอง",
  "block.minecraft.bubble_coral_block": "บล็อกปะการังฟอง",
  "block.minecraft.fire_coral_block": "บล็อกปะการังไฟ",
  "block.minecraft.horn_coral_block": "บล็อกปะการังเขา",
  "block.minecraft.tube_coral": "ปะการังหลอด",
  "block.minecraft.brain_coral": "ปะการังสมอง",
  "block.minecraft.bubble_coral": "ปะการังฟอง",
  "block.minecraft.fire_coral": "ปะการังไฟ",
  "block.minecraft.horn_coral": "ปะการังเขา",
  "block.minecraft.dead_brain_coral": "ปะการังสมองตาย",
  "block.minecraft.dead_bubble_coral": "ปะการังฟองตาย",
  "block.minecraft.dead_fire_coral": "ประการังไฟตาย",
  "block.minecraft.dead_horn_coral": "ปะการังเขาตาย",
  "block.minecraft.dead_tube_coral": "ปะการังหลอดตาย",
  "block.minecraft.tube_coral_fan": "ปะการังหลอดรูปพัด",
  "block.minecraft.brain_coral_fan": "ปะการังสมองรูปพัด",
  "block.minecraft.bubble_coral_fan": "ปะการังฟองรูปพัด",
  "block.minecraft.fire_coral_fan": "ปะการังไฟรูปพัด",
  "block.minecraft.horn_coral_fan": "ปะการังเขารูปพัด",
  "block.minecraft.dead_tube_coral_fan": "ปะการังหลอดรูปพัดตาย",
  "block.minecraft.dead_brain_coral_fan": "ปะการังสมองรูปพัดตาย",
  "block.minecraft.dead_bubble_coral_fan": "ปะการังฟองรูปพัดตาย",
  "block.minecraft.dead_fire_coral_fan": "ปะการังไฟรูปพัดตาย",
  "block.minecraft.dead_horn_coral_fan": "ปะการังเขารูปพัดตาย",
  "block.minecraft.blue_ice": "น้ำแข็งน้ำเงิน",
  "block.minecraft.conduit": "ศิรา",
  "block.minecraft.polished_granite_stairs": "บันไดหินแกรนิตขัด",
  "block.minecraft.smooth_red_sandstone_stairs": "บันไดหินทรายแดงเรียบ",
  "block.minecraft.mossy_stone_brick_stairs": "บันไดอิฐหินมอสส์",
  "block.minecraft.polished_diorite_stairs": "บันไดหินไดออไรต์ขัด",
  "block.minecraft.mossy_cobblestone_stairs": "บันไดหินหยาบมอสส์",
  "block.minecraft.end_stone_brick_stairs": "บันไดอิฐหินเอนด์",
  "block.minecraft.stone_stairs": "บันไดหิน",
  "block.minecraft.smooth_sandstone_stairs": "บันไดหินทรายเรียบ",
  "block.minecraft.smooth_quartz_stairs": "บันไดควอตซ์เรียบ",
  "block.minecraft.granite_stairs": "บันไดหินแกรนิต",
  "block.minecraft.andesite_stairs": "บันไดหินแอนดีไซต์",
  "block.minecraft.red_nether_brick_stairs": "บันไดอิฐเนเธอร์แดง",
  "block.minecraft.polished_andesite_stairs": "บันไดหินแอนดีไซต์ขัด",
  "block.minecraft.diorite_stairs": "บันไดหินไดออไรต์",
  "block.minecraft.polished_granite_slab": "แผ่นหินแกรนิตขัด",
  "block.minecraft.smooth_red_sandstone_slab": "แผ่นหินทรายแดงเรียบ",
  "block.minecraft.mossy_stone_brick_slab": "แผ่นอิฐหินมอสส์",
  "block.minecraft.polished_diorite_slab": "แผ่นหินไดออไรต์ขัด",
  "block.minecraft.mossy_cobblestone_slab": "แผ่นหินหยาบมอสส์",
  "block.minecraft.end_stone_brick_slab": "แผ่นอิฐหินเอนด์",
  "block.minecraft.smooth_sandstone_slab": "แผ่นหินทรายเรียบ",
  "block.minecraft.smooth_quartz_slab": "แผ่นควอตซ์เรียบ",
  "block.minecraft.granite_slab": "แผ่นหินแกรนิต",
  "block.minecraft.andesite_slab": "แผ่นหินแอนดีไซต์",
  "block.minecraft.red_nether_brick_slab": "แผ่นอิฐเนเธอร์แดง",
  "block.minecraft.polished_andesite_slab": "แผ่นหินแอนดีไซต์ขัด",
  "block.minecraft.diorite_slab": "แผ่นหินไดออไรต์",
  "block.minecraft.scaffolding": "นั่งร้าน",
  "block.minecraft.iron_door": "ประตูเหล็ก",
  "block.minecraft.oak_door": "ประตูไม้โอ๊ก",
  "block.minecraft.spruce_door": "ประตูไม้สนสปรูซ",
  "block.minecraft.birch_door": "ประตูไม้เบิร์ช",
  "block.minecraft.jungle_door": "ประตูไม้ป่าดงดิบ",
  "block.minecraft.acacia_door": "ประตูไม้อะเคเซีย",
  "block.minecraft.dark_oak_door": "ประตูไม้โอ๊กดำ",
  "block.minecraft.crimson_door": "ประตูไม้สีเลือด",
  "block.minecraft.warped_door": "ประตูไม้ป่าวิปริต",
  "block.minecraft.repeater": "ตัวทวนสัญญาณเรดสโตน",
  "block.minecraft.comparator": "ตัวเปรียบเทียบเรดสโตน",
  "block.minecraft.structure_block": "บล็อกโครงสร้าง",
  "block.minecraft.jigsaw": "บล็อกจิ๊กซอว์",
  "item.minecraft.turtle_helmet": "กระดองเต่า□□เมื่ออยู่บนหัว:□+2 เกราะ",
  "item.minecraft.scute": "เกล็ดเต่า",
  "item.minecraft.iron_shovel": "พลั่วเหล็ก□□เมื่ออยู่ในมือหลัก:□+3.5 ดาเมจโจมตี□-3 ความเร็วโจมตี",
  "item.minecraft.iron_pickaxe": "อีเต้อเหล็ก□□เมื่ออยู่ในมือหลัก:□+3 ดาเมจโจมตี□-2.8 ความเร็วโจมตี",
  "item.minecraft.iron_axe": "ขวานเหล็ก□□เมื่ออยู่ในมือหลัก:□+8 ดาเมจโจมตี□-3.1 ความเร็วโจมตี",
  "item.minecraft.flint_and_steel": "หินเหล็กไฟกับเหล็กกล้า",
  "item.minecraft.apple": "แอปเปิล",
  "item.minecraft.bow": "คันธนู",
  "item.minecraft.arrow": "ลูกธนู",
  "item.minecraft.coal": "ถ่านหิน",
  "item.minecraft.charcoal": "ถ่านไม้",
  "item.minecraft.diamond": "เพชร",
  "item.minecraft.iron_ingot": "แท่งเหล็ก",
  "item.minecraft.gold_ingot": "แท่งทอง",
  "item.minecraft.netherite_ingot": "แท่งเนเธอไรต์",
  "item.minecraft.netherite_scrap": "เศษเนเธอไรต์",
  "item.minecraft.iron_sword": "ดาบเหล็ก□□เมื่ออยู่ในมือหลัก:□+5 ดาเมจโจมตี□-2.4 ความเร็วโจมตี",
  "item.minecraft.wooden_sword": "ดาบไม้□□เมื่ออยู่ในมือหลัก:□+3 ดาเมจโจมตี□-2.4 ความเร็วโจมตี",
  "item.minecraft.wooden_shovel": "พลั่วไม้□□เมื่ออยู่ในมือหลัก:□+1.5 ดาเมจโจมตี□-3 ความเร็วโจมตี",
  "item.minecraft.wooden_pickaxe": "อีเต้อไม้□□เมื่ออยู่ในมือหลัก:□+1 ดาเมจโจมตี□-2.8 ความเร็วโจมตี",
  "item.minecraft.wooden_axe": "ขวานไม้□□เมื่ออยู่ในมือหลัก:□+6 ดาเมจโจมตี□-3.2 ความเร็วโจมตี",
  "item.minecraft.stone_sword": "ดาบหิน□□เมื่ออยู่ในมือหลัก:□+4 ดาเมจโจมตี□-2.4 ความเร็วโจมตี",
  "item.minecraft.stone_shovel": "พลั่วหิน□□เมื่ออยู่ในมือหลัก:□+2.5 ดาเมจโจมตี□-3 ความเร็วโจมตี",
  "item.minecraft.stone_pickaxe": "อีเต้อหิน□□เมื่ออยู่ในมือหลัก:□+2 ดาเมจโจมตี□-2.8 ความเร็วโจมตี",
  "item.minecraft.stone_axe": "ขวานหิน□□เมื่ออยู่ในมือหลัก:□+8 ดาเมจโจมตี□-3.2 ความเร็วโจมตี",
  "item.minecraft.diamond_sword": "ดาบเพชร□□เมื่ออยู่ในมือหลัก:□+6 ดาเมจโจมตี□-2.4 ความเร็วโจมตี",
  "item.minecraft.diamond_shovel": "พลั่วเพชร□□เมื่ออยู่ในมือหลัก:□+4.5 ดาเมจโจมตี□-3 ความเร็วโจมตี",
  "item.minecraft.diamond_pickaxe": "อีเต้อเพชร□□เมื่ออยู่ในมือหลัก:□+4 ดาเมจโจมตี□-2.8 ความเร็วโจมตี",
  "item.minecraft.diamond_axe": "ขวานเพชร□□เมื่ออยู่ในมือหลัก:□+8 ดาเมจโจมตี□-3 ความเร็วโจมตี",
  "item.minecraft.stick": "แท่งไม้",
  "item.minecraft.bowl": "ชาม",
  "item.minecraft.mushroom_stew": "สตูว์เห็ด",
  "item.minecraft.golden_sword": "ดาบทอง□□เมื่ออยู่ในมือหลัก:□+3 ดาเมจโจมตี□-2.4 ความเร็วโจมตี",
  "item.minecraft.golden_shovel": "พลั่วทอง□□เมื่ออยู่ในมือหลัก:□+1.5 ดาเมจโจมตี□-3 ความเร็วโจมตี",
  "item.minecraft.golden_pickaxe": "อีเต้อทอง□□เมื่ออยู่ในมือหลัก:□+1 ดาเมจโจมตี□-2.8 ความเร็วโจมตี",
  "item.minecraft.golden_axe": "ขวานทอง□□เมื่ออยู่ในมือหลัก:□+6 ดาเมจโจมตี□-3 ความเร็วโจมตี",
  "item.minecraft.netherite_sword": "ดาบเนเธอไรต์□□เมื่ออยู่ในมือหลัก:□+7 ดาเมจโจมตี□-2.4 ความเร็วโจมตี",
  "item.minecraft.netherite_shovel": "พลั่วเนเธอไรต์□□เมื่ออยู่ในมือหลัก:□+5.5 ดาเมจโจมตี□-3 ความเร็วโจมตี",
  "item.minecraft.netherite_pickaxe": "อีเต้อเนเธอไรต์□□เมื่ออยู่ในมือหลัก:□+5 ดาเมจโจมตี□-2.8 ความเร็วโจมตี",
  "item.minecraft.netherite_axe": "ขวานเนเธอไรต์□□เมื่ออยู่ในมือหลัก:□+9 ดาเมจโจมตี□-3 ความเร็วโจมตี",
  "item.minecraft.string": "เส้นใย",
  "item.minecraft.feather": "ขนนก",
  "item.minecraft.gunpowder": "ดินปืน",
  "item.minecraft.wooden_hoe": "จอบไม้□□เมื่ออยู่ในมือหลัก:□-3 ความเร็วโจมตี",
  "item.minecraft.stone_hoe": "จอบหิน□□เมื่ออยู่ในมือหลัก:□-2 ความเร็วโจมตี",
  "item.minecraft.iron_hoe": "จอบเหล็ก□□เมื่ออยู่ในมือหลัก:□-1 ความเร็วโจมตี",
  "item.minecraft.diamond_hoe": "จอบเพชร□□เมื่ออยู่ในมือหลัก:",
  "item.minecraft.golden_hoe": "จอบทอง□□เมื่ออยู่ในมือหลัก:□-3 ความเร็วโจมตี",
  "item.minecraft.netherite_hoe": "จอบเนเธอไรต์□□เมื่ออยู่ในมือหลัก:",
  "item.minecraft.wheat_seeds": "เมล็ดข้าวสาลี",
  "item.minecraft.wheat": "ข้าวสาลี",
  "item.minecraft.bread": "ขนมปัง",
  "item.minecraft.leather_helmet": "หมวกหนัง□□เมื่ออยู่บนหัว:□+1 เกราะ",
  "item.minecraft.leather_chestplate": "เสื้อคลุมหนัง□□เมื่อส่วมใส่ที่ตัว:□+3 เกราะ",
  "item.minecraft.leather_leggings": "กางเกงหนัง□□เมื่ออยู่ที่ขา:□+2 เกราะ",
  "item.minecraft.leather_boots": "รองเท้าหนัง□□เมื่ออยู่ที่เท้า:□+1 เกราะ",
  "item.minecraft.chainmail_helmet": "หมวกโซ่□□เมื่ออยู่บนหัว:□+2 เกราะ",
  "item.minecraft.chainmail_chestplate": "เสื้อเกราะโซ่□□เมื่อส่วมใส่ที่ตัว:□+5 เกราะ",
  "item.minecraft.chainmail_leggings": "กางเกงโซ่□□เมื่ออยู่ที่ขา:□+4 เกราะ",
  "item.minecraft.chainmail_boots": "รองเท้าโซ่□□เมื่ออยู่ที่เท้า:□+1 เกราะ",
  "item.minecraft.iron_helmet": "หมวกเหล็ก□□เมื่ออยู่บนหัว:□+2 เกราะ",
  "item.minecraft.iron_chestplate": "เสื้อเกราะเหล็ก□□เมื่อส่วมใส่ที่ตัว:□+6 เกราะ",
  "item.minecraft.iron_leggings": "กางเกงเหล็ก□□เมื่ออยู่ที่ขา:□+5 เกราะ",
  "item.minecraft.iron_boots": "รองเท้าเหล็ก□□เมื่ออยู่ที่เท้า:□+2 เกราะ",
  "item.minecraft.diamond_helmet": "หมวกเพชร□□เมื่ออยู่บนหัว:□+3 เกราะ□+2 ความแข็งแกร่งของเกราะ",
  "item.minecraft.diamond_chestplate": "เสื้อเกราะเพชร□□เมื่อส่วมใส่ที่ตัว:□+8 เกราะ□+2 ความแข็งแกร่งของเกราะ",
  "item.minecraft.diamond_leggings": "กางเกงเพชร□□เมื่ออยู่ที่ขา:□+6 เกราะ□+2 ความแข็งแกร่งของเกราะ",
  "item.minecraft.diamond_boots": "รองเท้าเพชร□□เมื่ออยู่ที่เท้า:□+3 เกราะ□+2 ความแข็งแกร่งของเกราะ",
  "item.minecraft.golden_helmet": "หมวกทอง□□เมื่ออยู่บนหัว:□+2 เกราะ",
  "item.minecraft.golden_chestplate": "เสื้อเกราะทอง□□เมื่อส่วมใส่ที่ตัว:□+5 เกราะ",
  "item.minecraft.golden_leggings": "กางเกงทอง□□เมื่ออยู่ที่ขา:□+3 เกราะ",
  "item.minecraft.golden_boots": "รองเท้าทอง□□เมื่ออยู่ที่เท้า:□+1 เกราะ",
  "item.minecraft.netherite_helmet": "หมวกเนเธอไรต์□□เมื่ออยู่บนหัว:□+3 เกราะ□+3 ความแข็งแกร่งของเกราะ□+1 ความต้านทานการกระดอน",
  "item.minecraft.netherite_chestplate": "เสื้อเกราะเนเธอไรต์□□เมื่อส่วมใส่ที่ตัว:□+8 เกราะ□+3 ความแข็งแกร่งของเกราะ□+1 ความต้านทานการกระดอน",
  "item.minecraft.netherite_leggings": "กางเกงเนเธอไรต์□□เมื่ออยู่ที่ขา:□+6 เกราะ□+3 ความแข็งแกร่งของเกราะ□+1 ความต้านทานการกระดอน",
  "item.minecraft.netherite_boots": "รองเท้าเนเธอไรต์□□เมื่ออยู่ที่เท้า:□+3 เกราะ□+3 ความแข็งแกร่งของเกราะ□+1 ความต้านทานการกระดอน",
  "item.minecraft.flint": "หินเหล็กไฟ",
  "item.minecraft.porkchop": "เนื้อหมูดิบ",
  "item.minecraft.cooked_porkchop": "เนื้อหมูปรุงสุก",
  "item.minecraft.painting": "ภาพวาด",
  "item.minecraft.golden_apple": "แอปเปิลทอง",
  "item.minecraft.enchanted_golden_apple": "แอปเปิลทองร่ายมนตร์",
  "block.minecraft.oak_sign": "ป้ายไม้โอ๊ก",
  "block.minecraft.spruce_sign": "ป้ายไม้สนสปรูซ",
  "block.minecraft.birch_sign": "ป้ายไม้เบิร์ช",
  "block.minecraft.jungle_sign": "ป้ายไม้ป่าดงดิบ",
  "block.minecraft.acacia_sign": "ป้ายไม้อะเคเซีย",
  "block.minecraft.dark_oak_sign": "ป้ายไม้โอ๊กดำ",
  "block.minecraft.crimson_sign": "ป้ายไม้สีเลือด",
  "block.minecraft.warped_sign": "ป้ายไม้ป่าวิปริต",
  "item.minecraft.bucket": "ถัง",
  "item.minecraft.water_bucket": "ถังน้ำ",
  "item.minecraft.lava_bucket": "ถังลาวา",
  "item.minecraft.minecart": "รถราง",
  "item.minecraft.saddle": "อาน",
  "item.minecraft.redstone": "ผงเรดสโตน",
  "item.minecraft.snowball": "ก้อนหิมะ",
  "item.minecraft.oak_boat": "เรือไม้โอ๊ก",
  "item.minecraft.leather": "หนังสัตว์",
  "item.minecraft.milk_bucket": "ถังนม",
  "item.minecraft.pufferfish_bucket": "ถังปลาปักเป้า",
  "item.minecraft.salmon_bucket": "ถังปลาแซลมอน",
  "item.minecraft.cod_bucket": "ถังปลาค็อด",
  "item.minecraft.tropical_fish_bucket": "ถังปลาเขตร้อน",
  "item.minecraft.brick": "อิฐ",
  "item.minecraft.clay_ball": "ก้อนดินเหนียว",
  "block.minecraft.dried_kelp_block": "บล็อกสาหร่ายทะเลแห้ง",
  "item.minecraft.paper": "กระดาษ",
  "item.minecraft.book": "หนังสือ",
  "item.minecraft.slime_ball": "ก้อนสไลม์",
  "item.minecraft.chest_minecart": "รถรางพร้อมหีบ",
  "item.minecraft.furnace_minecart": "รถรางพร้อมเตาเผา",
  "item.minecraft.egg": "ไข่",
  "item.minecraft.compass": "เข็มทิศ",
  "item.minecraft.fishing_rod": "คันเบ็ดตกปลา",
  "item.minecraft.clock": "นาฬิกา",
  "item.minecraft.glowstone_dust": "ผงหินเรืองแสง",
  "item.minecraft.cod": "ปลาค็อดดิบ",
  "item.minecraft.salmon": "ปลาแซลมอนดิบ",
  "item.minecraft.tropical_fish": "ปลาเขตร้อน",
  "item.minecraft.pufferfish": "ปลาปักเป้า",
  "item.minecraft.cooked_cod": "ปลาค็อดปรุงสุก",
  "item.minecraft.cooked_salmon": "ปลาแซลมอนปรุงสุก",
  "item.minecraft.ink_sac": "ถุงหมึก",
  "item.minecraft.red_dye": "สีย้อมสีแดง",
  "item.minecraft.green_dye": "สีย้อมสีเขียว",
  "item.minecraft.cocoa_beans": "เมล็ดโกโก้",
  "item.minecraft.lapis_lazuli": "แลพิสแลซูลี",
  "item.minecraft.purple_dye": "สีย้อมสีม่วง",
  "item.minecraft.cyan_dye": "สีย้อมสีฟ้าคราม",
  "item.minecraft.light_gray_dye": "สีย้อมสีเทาอ่อน",
  "item.minecraft.gray_dye": "สีย้อมสีเทา",
  "item.minecraft.pink_dye": "สีย้อมสีชมพู",
  "item.minecraft.lime_dye": "สีย้อมสีเขียวอ่อน",
  "item.minecraft.yellow_dye": "สีย้อมสีเหลือง",
  "item.minecraft.light_blue_dye": "สีย้อมสีฟ้า",
  "item.minecraft.magenta_dye": "สีย้อมสีบานเย็น",
  "item.minecraft.orange_dye": "สีย้อมสีส้ม",
  "item.minecraft.bone_meal": "ผงกระดูก",
  "item.minecraft.blue_dye": "สีย้อมสีน้ำเงิน",
  "item.minecraft.brown_dye": "สีย้อมสีน้ำตาล",
  "item.minecraft.black_dye": "สีย้อมสีดำ",
  "item.minecraft.white_dye": "สีย้อมสีขาว",
  "item.minecraft.bone": "กระดูก",
  "item.minecraft.sugar": "น้ำตาล",
  "block.minecraft.cake": "เค้ก",
  "block.minecraft.white_bed": "เตียงสีขาว",
  "block.minecraft.orange_bed": "เตียงสีส้ม",
  "block.minecraft.magenta_bed": "เตียงสีบานเย็น",
  "block.minecraft.light_blue_bed": "เตียงสีฟ้า",
  "block.minecraft.yellow_bed": "เตียงสีเหลือง",
  "block.minecraft.lime_bed": "เตียงสีเขียวอ่อน",
  "block.minecraft.pink_bed": "เตียงสีชมพู",
  "block.minecraft.gray_bed": "เตียงสีเทา",
  "block.minecraft.light_gray_bed": "เตียงสีเทาอ่อน",
  "block.minecraft.cyan_bed": "เตียงสีฟ้าคราม",
  "block.minecraft.purple_bed": "เตียงสีม่วง",
  "block.minecraft.blue_bed": "เตียงสีน้ำเงิน",
  "block.minecraft.brown_bed": "เตียงสีน้ำตาล",
  "block.minecraft.green_bed": "เตียงสีเขียว",
  "block.minecraft.red_bed": "เตียงสีแดง",
  "block.minecraft.black_bed": "เตียงสีดำ",
  "item.minecraft.cookie": "คุกกี้",
  "item.minecraft.filled_map": "แผนที่□#0",
  "item.minecraft.shears": "กรรไกร",
  "item.minecraft.melon_slice": "ชิ้นแตงโม",
  "item.minecraft.dried_kelp": "สาหร่ายทะเลแห้ง",
  "item.minecraft.pumpkin_seeds": "เมล็ดฟักทอง",
  "item.minecraft.melon_seeds": "เมล็ดแตงโม",
  "item.minecraft.beef": "เนื้อวัวดิบ",
  "item.minecraft.cooked_beef": "สเต๊ก",
  "item.minecraft.chicken": "เนื้อไก่ดิบ",
  "item.minecraft.cooked_chicken": "เนื้อไก่ปรุงสุก",
  "item.minecraft.rotten_flesh": "เนื้อเน่า",
  "item.minecraft.ender_pearl": "ไข่มุกเอนเดอร์",
  "item.minecraft.blaze_rod": "แท่งเบลช",
  "item.minecraft.ghast_tear": "น้ำตาแก๊สต์",
  "item.minecraft.gold_nugget": "เศษทอง",
  "item.minecraft.nether_wart": "หูดเนเธอร์",
  "item.minecraft.potion": "น้ำยาที่ไม่สามารถปรุงได้□ไม่มีเอฟเฟกต์",
  "item.minecraft.glass_bottle": "ขวดแก้ว",
  "item.minecraft.spider_eye": "ตาแมงมุม",
  "item.minecraft.fermented_spider_eye": "ตาแมงมุมดอง",
  "item.minecraft.blaze_powder": "ผงเบลซ",
  "item.minecraft.magma_cream": "ครีมสไลม์ไฟ",
  "block.minecraft.brewing_stand": "แท่นปรุงยา",
  "block.minecraft.cauldron": "หม้อปรุงยา",
  "item.minecraft.ender_eye": "ดวงตาแห่งเอนเดอร์",
  "item.minecraft.glistering_melon_slice": "ชิ้นแตงโมทอง",
  "item.minecraft.bat_spawn_egg": "ไข่เกิดค้างคาว",
  "item.minecraft.bee_spawn_egg": "ไข่เกิดผึ้ง",
  "item.minecraft.blaze_spawn_egg": "ไข่เกิดเบลซ",
  "item.minecraft.cat_spawn_egg": "ไข่เกิดแมว",
  "item.minecraft.cave_spider_spawn_egg": "ไข่เกิดแมงมุมถ้ำ",
  "item.minecraft.chicken_spawn_egg": "ไข่เกิดไก่",
  "item.minecraft.cod_spawn_egg": "ไข่เกิดปลาค็อด",
  "item.minecraft.cow_spawn_egg": "ไข่เกิดวัว",
  "item.minecraft.creeper_spawn_egg": "ไข่เกิดครีปเปอร์",
  "item.minecraft.dolphin_spawn_egg": "ไข่เกิดโลมา",
  "item.minecraft.donkey_spawn_egg": "ไข่เกิดลา",
  "item.minecraft.drowned_spawn_egg": "ไข่เกิดซอมบี้ใต้น้ำ",
  "item.minecraft.elder_guardian_spawn_egg": "ไข่เกิดพญาการ์เดียน",
  "item.minecraft.enderman_spawn_egg": "ไข่เกิดเอนเดอร์แมน",
  "item.minecraft.endermite_spawn_egg": "ไข่เกิดเอนเดอร์ไมต์",
  "item.minecraft.evoker_spawn_egg": "ไข่เกิดอีโวกเกอร์",
  "item.minecraft.fox_spawn_egg": "ไข่เกิดหมาจิ้งจอก",
  "item.minecraft.ghast_spawn_egg": "ไข่เกิดแก๊สต์",
  "item.minecraft.guardian_spawn_egg": "ไข่เกิดการ์เดียน",
  "item.minecraft.hoglin_spawn_egg": "ไข่เกิดฮอกลิน",
  "item.minecraft.horse_spawn_egg": "ไข่เกิดม้า",
  "item.minecraft.husk_spawn_egg": "ไข่เกิดซอมบี้ทะเลทราย",
  "item.minecraft.llama_spawn_egg": "ไข่เกิดลามะ",
  "item.minecraft.magma_cube_spawn_egg": "ไข่เกิดสไลม์ไฟ",
  "item.minecraft.mooshroom_spawn_egg": "ไข่เกิดมูชรูม",
  "item.minecraft.mule_spawn_egg": "ไข่เกิดล่อ",
  "item.minecraft.ocelot_spawn_egg": "ไข่เกิดแมวป่า",
  "item.minecraft.panda_spawn_egg": "ไข่เกิดหมีแพนด้า",
  "item.minecraft.parrot_spawn_egg": "ไข่เกิดนกแก้ว",
  "item.minecraft.phantom_spawn_egg": "ไข่เกิดแฟนท่อม",
  "item.minecraft.pig_spawn_egg": "ไข่เกิดหมู",
  "item.minecraft.piglin_spawn_egg": "ไข่เกิดพิกลิน",
  "item.minecraft.pillager_spawn_egg": "ไข่เกิดกองโจร",
  "item.minecraft.polar_bear_spawn_egg": "ไข่เกิดหมีขั้วโลก",
  "item.minecraft.pufferfish_spawn_egg": "ไข่เกิดปลาปักเป้า",
  "item.minecraft.rabbit_spawn_egg": "ไข่เกิดกระต่าย",
  "item.minecraft.ravager_spawn_egg": "ไข่เกิดปีศาจปล้นสะดม",
  "item.minecraft.salmon_spawn_egg": "ไข่เกิดปลาแซลมอน",
  "item.minecraft.sheep_spawn_egg": "ไข่เกิดแกะ",
  "item.minecraft.shulker_spawn_egg": "ไข่เกิดชัลเกอร์",
  "item.minecraft.silverfish_spawn_egg": "ไข่เกิดแมลงสามง่าม",
  "item.minecraft.skeleton_spawn_egg": "ไข่เกิดโครงกระดูก",
  "item.minecraft.skeleton_horse_spawn_egg": "ไข่เกิดม้าโครงกระดูก",
  "item.minecraft.slime_spawn_egg": "ไข่เกิดสไลม์",
  "item.minecraft.spider_spawn_egg": "ไข่เกิดแมงมุม",
  "item.minecraft.squid_spawn_egg": "ไข่เกิดหมึก",
  "item.minecraft.stray_spawn_egg": "ไข่เกิดโครงกระดูกน้ำแข็ง",
  "item.minecraft.strider_spawn_egg": "ไข่เกิดสไตรเดอร์",
  "item.minecraft.trader_llama_spawn_egg": "ไข่เกิดลามาพ่อค้า",
  "item.minecraft.tropical_fish_spawn_egg": "ไข่เกิดปลาเขตร้อน",
  "item.minecraft.turtle_spawn_egg": "ไข่เกิดเต่า",
  "item.minecraft.vex_spawn_egg": "ไข่เกิดเวกซ์",
  "item.minecraft.villager_spawn_egg": "ไข่เกิดชาวบ้าน",
  "item.minecraft.vindicator_spawn_egg": "ไข่เกิดวินดิเคเตอร์",
  "item.minecraft.wandering_trader_spawn_egg": "ไข่เกิดพ่อค้าเร่ร่อน",
  "item.minecraft.witch_spawn_egg": "ไข่เกิดแม่มด",
  "item.minecraft.wither_skeleton_spawn_egg": "ไข่เกิดโครงกระดูกวิทเธอร์",
  "item.minecraft.wolf_spawn_egg": "ไข่เกิดหมาป่า",
  "item.minecraft.zoglin_spawn_egg": "ไข่เกิดซอกลิน",
  "item.minecraft.zombie_spawn_egg": "ไข่เกิดซอมบี้",
  "item.minecraft.zombie_horse_spawn_egg": "ไข่เกิดม้าซอมบี้",
  "item.minecraft.zombie_villager_spawn_egg": "ไข่เกิดชาวบ้านซอมบี้",
  "item.minecraft.zombified_piglin_spawn_egg": "ไข่เกิดพิกลินซอมบี้",
  "item.minecraft.experience_bottle": "ขวดแห่งเวทมนตร์",
  "item.minecraft.fire_charge": "ประจุไฟ",
  "item.minecraft.writable_book": "หนังสือกับปากกาขนนก",
  "item.minecraft.written_book": "หนังสือเขียน",
  "item.minecraft.emerald": "มรกต",
  "item.minecraft.item_frame": "กรอบไอเทม",
  "block.minecraft.flower_pot": "กระถางดอกไม้",
  "item.minecraft.carrot": "แคร์รอต",
  "item.minecraft.potato": "มันฝรั่ง",
  "item.minecraft.baked_potato": "มันฝรั่งอบ",
  "item.minecraft.poisonous_potato": "มันฝรั่งพิษ",
  "item.minecraft.map": "แผนที่เปล่า",
  "item.minecraft.golden_carrot": "แคร์รอตทอง",
  "block.minecraft.skeleton_skull": "กะโหลกโครงกระดูก",
  "block.minecraft.wither_skeleton_skull": "กะโหลกโครงกระดูกวิทเธอร์",
  "block.minecraft.player_head": "หัวผู้เล่น",
  "block.minecraft.zombie_head": "หัวซอมบี้",
  "block.minecraft.creeper_head": "หัวครีปเปอร์",
  "block.minecraft.dragon_head": "หัวมังกร",
  "item.minecraft.carrot_on_a_stick": "แคร์รอตติดเบ็ด",
  "item.minecraft.warped_fungus_on_a_stick": "เห็ดราป่าวิปริตติดเบ็ด",
  "item.minecraft.nether_star": "ดาวเนเธอร์",
  "item.minecraft.pumpkin_pie": "พายฟักทอง",
  "item.minecraft.firework_rocket": "จรวดพลุ",
  "item.minecraft.firework_star": "ดาวดอกไม้ไฟ",
  "item.minecraft.enchanted_book": "หนังสือร่ายมนตร์",
  "item.minecraft.nether_brick": "อิฐเนเธอร์",
  "item.minecraft.quartz": "ควอตซ์เนเธอร์",
  "item.minecraft.tnt_minecart": "รถรางพร้อมระเบิดทีเอ็นที",
  "item.minecraft.hopper_minecart": "รถรางพร้อมท่อส่ง",
  "item.minecraft.prismarine_shard": "เศษพริสมารีน",
  "item.minecraft.prismarine_crystals": "ผลึกพริสมารีน",
  "item.minecraft.rabbit": "เนื้อกระต่ายดิบ",
  "item.minecraft.cooked_rabbit": "เนื้อกระต่ายปรุงสุก",
  "item.minecraft.rabbit_stew": "สตูว์กระต่าย",
  "item.minecraft.rabbit_foot": "เท้ากระต่าย",
  "item.minecraft.rabbit_hide": "หนังกระต่าย",
  "item.minecraft.armor_stand": "แท่นวางชุดเกราะ",
  "item.minecraft.iron_horse_armor": "เกราะม้าเหล็ก",
  "item.minecraft.golden_horse_armor": "เกราะม้าทอง",
  "item.minecraft.diamond_horse_armor": "เกราะม้าเพชร",
  "item.minecraft.leather_horse_armor": "เกราะม้าหนัง",
  "item.minecraft.lead": "เชือกจูง",
  "item.minecraft.name_tag": "ป้ายชื่อ",
  "item.minecraft.command_block_minecart": "รถรางพร้อมบล็อกคำสั่ง",
  "item.minecraft.mutton": "เนื้อแกะดิบ",
  "item.minecraft.cooked_mutton": "เนื้อแกะปรุงสุก",
  "block.minecraft.white_banner": "ธงสีขาว",
  "block.minecraft.orange_banner": "ธงสีส้ม",
  "block.minecraft.magenta_banner": "ธงสีบานเย็น",
  "block.minecraft.light_blue_banner": "ธงสีฟ้า",
  "block.minecraft.yellow_banner": "ธงสีเหลือง",
  "block.minecraft.lime_banner": "ธงสีเขียวอ่อน",
  "block.minecraft.pink_banner": "ธงสีชมพู",
  "block.minecraft.gray_banner": "ธงสีเทา",
  "block.minecraft.light_gray_banner": "ธงสีเทาอ่อน",
  "block.minecraft.cyan_banner": "ธงสีฟ้าคราม",
  "block.minecraft.purple_banner": "ธงสีม่วง",
  "block.minecraft.blue_banner": "ธงสีน้ำเงิน",
  "block.minecraft.brown_banner": "ธงสีน้ำตาล",
  "block.minecraft.green_banner": "ธงสีเขียว",
  "block.minecraft.red_banner": "ธงสีแดง",
  "block.minecraft.black_banner": "ธงสีดำ",
  "item.minecraft.end_crystal": "ผลึกเอนด์",
  "item.minecraft.chorus_fruit": "ผลคอรัส",
  "item.minecraft.popped_chorus_fruit": "ผลคอรัสสุก",
  "item.minecraft.beetroot": "บีตรูต",
  "item.minecraft.beetroot_seeds": "เมล็ดบีตรูต",
  "item.minecraft.beetroot_soup": "ซุปบีตรูต",
  "item.minecraft.dragon_breath": "ลมหายใจมังกร",
  "item.minecraft.splash_potion": "น้ำยาแบบปาที่ไม่สามารถปรุงได้□ไม่มีเอฟเฟกต์",
  "item.minecraft.spectral_arrow": "ลูกธนูเรืองแสง",
  "item.minecraft.tipped_arrow": "ลูกธนูอาบยาที่ไม่สามารถคราฟต์ได้□ไม่มีเอฟเฟกต์",
  "item.minecraft.lingering_potion": "น้ำยาแบบระเหยที่ไม่สามารถปรุงได้□ไม่มีเอฟเฟกต์",
  "item.minecraft.shield": "โล่",
  "item.minecraft.elytra": "ปีก",
  "item.minecraft.spruce_boat": "เรือไม้สนสปรูซ",
  "item.minecraft.birch_boat": "เรือไม้เบิร์ช",
  "item.minecraft.jungle_boat": "เรือไม้ป่าดงดิบ",
  "item.minecraft.acacia_boat": "เรือไม้อะเคเซีย",
  "item.minecraft.dark_oak_boat": "เรือไม้โอ๊กดำ",
  "item.minecraft.totem_of_undying": "เครื่องรางคลาดแคล้ว",
  "item.minecraft.shulker_shell": "เปลือกชัลเกอร์",
  "item.minecraft.iron_nugget": "เศษเหล็ก",
  "item.minecraft.knowledge_book": "หนังสือความรู้",
  "item.minecraft.debug_stick": "แท่งไม้ดีบั๊ก",
  "item.minecraft.music_disc_13": "แผ่นเสียง□c418 - 13",
  "item.minecraft.music_disc_cat": "แผ่นเสียง□c418 - cat",
  "item.minecraft.music_disc_blocks": "แผ่นเสียง□c418 - blocks",
  "item.minecraft.music_disc_chirp": "แผ่นเสียง□c418 - chirp",
  "item.minecraft.music_disc_far": "แผ่นเสียง□c418 - far",
  "item.minecraft.music_disc_mall": "แผ่นเสียง□c418 - mall",
  "item.minecraft.music_disc_mellohi": "แผ่นเสียง□c418 - mellohi",
  "item.minecraft.music_disc_stal": "แผ่นเสียง□c418 - stal",
  "item.minecraft.music_disc_strad": "แผ่นเสียง□c418 - strad",
  "item.minecraft.music_disc_ward": "แผ่นเสียง□c418 - ward",
  "item.minecraft.music_disc_11": "แผ่นเสียง□c418 - 11",
  "item.minecraft.music_disc_wait": "แผ่นเสียง□c418 - wait",
  "item.minecraft.music_disc_pigstep": "แผ่นเสียง□lena raine - pigstep",
  "item.minecraft.trident": "ตรีศูล□□เมื่ออยู่ในมือหลัก:□+8 ดาเมจโจมตี□-2.9 ความเร็วโจมตี",
  "item.minecraft.phantom_membrane": "เยื่อแฟนท่อม",
  "item.minecraft.nautilus_shell": "เปลือกหอยงวงช้าง",
  "item.minecraft.heart_of_the_sea": "หัวใจแห่งท้องทะเล",
  "item.minecraft.crossbow": "หน้าไม้",
  "item.minecraft.suspicious_stew": "สตูว์พิศวง",
  "block.minecraft.loom": "เครื่องทอผ้า",
  "item.minecraft.flower_banner_pattern": "แบบลายธง□ตราสัญลักษณ์ดอกไม้",
  "item.minecraft.creeper_banner_pattern": "แบบลายธง□ตราสัญลักษณ์ครีปเปอร์",
  "item.minecraft.skull_banner_pattern": "แบบลายธง□ตราสัญลักษณ์กะโหลก",
  "item.minecraft.mojang_banner_pattern": "แบบลายธง□โลโก้ mojang",
  "item.minecraft.globe_banner_pattern": "แบบลายธง□ลูกโลก",
  "item.minecraft.piglin_banner_pattern": "แบบลายธง□จมูกหมู",
  "block.minecraft.composter": "ถังหมักปุ๋ย",
  "block.minecraft.barrel": "ถังบาร์เรล",
  "block.minecraft.smoker": "เตารมควัน",
  "block.minecraft.blast_furnace": "เตาหลอม",
  "block.minecraft.cartography_table": "โต๊ะทำแผนที่",
  "block.minecraft.fletching_table": "โต๊ะทำธนู",
  "block.minecraft.grindstone": "หินลับมีด",
  "block.minecraft.lectern": "แท่นอ่านหนังสือ",
  "block.minecraft.smithing_table": "โต๊ะทำอาวุธ",
  "block.minecraft.stonecutter": "เครื่องตัดหิน",
  "block.minecraft.bell": "ระฆัง",
  "block.minecraft.lantern": "โคมไฟ",
  "block.minecraft.soul_lantern": "โคมไฟวิญญาณ",
  "item.minecraft.sweet_berries": "เบอร์รี่หวาน",
  "block.minecraft.campfire": "แคมป์ไฟ",
  "block.minecraft.soul_campfire": "แคมป์ไฟวิญญาณ",
  "block.minecraft.shroomlight": "เห็ดเรืองแสง",
  "item.minecraft.honeycomb": "รวงผึ้ง",
  "block.minecraft.bee_nest": "รังผึ้ง",
  "block.minecraft.beehive": "กล่องรังผึ้ง",
  "item.minecraft.honey_bottle": "ขวดน้ำผึ้ง",
  "block.minecraft.honey_block": "บล็อกน้ำผึ้ง",
  "block.minecraft.honeycomb_block": "บล็อกรวงผึ้ง",
  "block.minecraft.lodestone": "หินนำทาง",
  "block.minecraft.netherite_block": "บล็อกเนเธอไรต์",
  "block.minecraft.ancient_debris": "เศษแร่โบราณ",
  "block.minecraft.target": "เป้ายิง",
  "block.minecraft.crying_obsidian": "หินออบซิเดียนร้องไห้",
  "block.minecraft.blackstone": "หินดำ",
  "block.minecraft.blackstone_slab": "แผ่นหินดำ",
  "block.minecraft.blackstone_stairs": "บันไดหินดำ",
  "block.minecraft.gilded_blackstone": "หินดำฝังทอง",
  "block.minecraft.polished_blackstone": "หินดำขัด",
  "block.minecraft.polished_blackstone_slab": "แผ่นหินดำขัด",
  "block.minecraft.polished_blackstone_stairs": "บันไดหินดำขัด",
  "block.minecraft.chiseled_polished_blackstone": "หินดำขัดสลัก",
  "block.minecraft.polished_blackstone_bricks": "อิฐหินดำขัด",
  "block.minecraft.polished_blackstone_brick_slab": "แผ่นอิฐหินดำขัด",
  "block.minecraft.polished_blackstone_brick_stairs": "บันไดอิฐหินดำขัด",
  "block.minecraft.cracked_polished_blackstone_bricks": "อิฐหินดำขัดร้าว",
  "block.minecraft.respawn_anchor": "หลักจุดเกิด",
}
export const th_th = items; 
